const BASKET_MODES = {
  NORMAL: 'normal',
  STATIC: 'static',
};

export default BASKET_MODES;
